import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { Genders } from '@workspace/data-types';
import { UserStore } from '@workspace/ng-data-access';

@Component({
  selector: 'core-user-identity-summary',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, DatePipe, RouterLink],
  templateUrl: './user-identity-summary.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserIdentitySummaryCoreComponent {
  private userStore = inject(UserStore);

  currentUser = this.userStore.currentUser;

  title = input<string>('Vérifiez vos informations');
  description = input<string>(
    "Avant de procéder à la vérification d'identité, assurez-vous que les informations suivantes correspondent à votre pièce d'identité.",
  );
  confirmLabel = input<string>("C'est correct, continuer");
  errorLabel = input<string>('Il y a une erreur');
  errorLink = input<string>('/user/settings');
  errorQueryParams = input<Record<string, unknown>>({ drawer: 'account' });

  confirmed = output<void>();

  genderLabel = computed(() => {
    const gender = this.currentUser()?.identity?.gender;
    switch (gender) {
      case Genders.MALE:
        return 'Homme';
      case Genders.FEMALE:
        return 'Femme';
      case Genders.OTHER:
        return 'Autre';
      default:
        return 'Non précisé';
    }
  });
}
